import { type LeishanSystem, type LeishanProfileLink } from '../src/types/leishan';
import { uris } from './environment';

export const mainSystems: LeishanSystem[] = [
    {
        name: 'BMS業務管理系統',
        uri: uris.BMS_URL,
        clientId: 'bms',
        target: '_self',
    },
    {
        name: 'KM知識家',
        uri: uris.KM_URL,
        clientId: 'km',
        target: '_self',
    },
    {
        name: 'PKS',
        uri: uris.PKS_URL,
        clientId: 'pks',
        target: '_blank',
    },
    {
        name: '線上繳費',
        uri: uris.LAB_URL + 'pay',
        clientId: 'lab',
        target: '_self',
    },
    {
        name: '考照系統',
        uri: uris.CERTIFICATION_URL,
        clientId: 'certification',
        target: '_self',
    },
    {
        name: '線上報聘',
        uri: uris.EIP_URL,
        clientId: 'eip',
        target: '_blank',
    },
    {
        name: '獎項系統',
        uri: uris.AWARD_URL,
        clientId: 'bmsAward',
        target: '_self',
    },
    {
        name: 'Drew',
        uri: uris.DREW_URL,
        clientId: 'drew',
        target: '_self',
    },
    {
        name: '磊山e學院',
        uri: uris.E_LEARNING_URL,
        clientId: 'e-learning',
        target: '_blank',
    },
    {
        name: 'Finfo',
        uri: uris.FINFO_URL,
        clientId: 'finfo',
        target: '_blank',
    },
];

export const subSystems: LeishanSystem[] = [
    {
        name: 'TIA',
        uri: uris.TIA_URL,
        target: '_blank',
    },
    {
        name: '磊山e管家',
        uri: uris.CTW_URL,
        target: '_blank',
    },
    {
        name: '磊山官網',
        uri: uris.OFFICIAL_URL,
        target: '_blank',
    },
    {
        name: '捐款後台',
        uri: uris.LAB_URL + 'donation/list',
        target: '_self',
        permission: (info) => info && info.is_donation_admin == '1',
    },
];

export const profileLinks: LeishanProfileLink[] = [
    {
        name: '新增業務支援帳號',
        uri: uris.LAB_URL + 'create-member',
        permission: (info) => info && info.role == 'admin',
    },
    {
        name: '用戶管理',
        uri: uris.LAB_URL + 'pay/member_manage',
        permission: (info) => info && info.edit_pay_item == '1',
    },
    { name: '修改個人資訊', uri: `${uris.BMS_URL}account?tab=updateinfo`, permission: (info) => info && !!info.role },
    { name: '修改密碼', uri: '', permission: (info) => info && !!info.role },
    {
        name: '重新設定TIA安全問題',
        uri: `${uris.BMS_URL}account?tab=resetTiaQuestion`,
        permission: (info) => info && !!info.role,
    },
    { name: '解除TIA綁定', uri: `${uris.BMS_URL}account?tab=unbindTia`, permission: (info) => info && !!info.role },
];
